import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map()
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHE__SET_BRANDS':
            return core.setBrands(state, action.brands);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Brands/reducer.js